export default __webpack_public_path__ + "static/media/DJI_0989.MP4.00_01_49_03.Still006.dd5fcf0e.jpg";